import {
  Box,
  Grid,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../../components/container-layout/ContainerLayout";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import ModalCustom from "../../../../components/modal/ModalCustom";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import { NavigateFunction, useLocation, useNavigate, useParams } from "react-router-dom";
import IndexProjectForm from "../components/IndexProjectForm";
import ContainerButton from "../../../../components/button/ContainerButton";
import {
  UploadedFile,
  InputValueProjectForm,
  defualtValueProjectForm,
} from "../components/domain";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../components/alert/swal";
import { edpexProjectAPI } from "../../../../api/edpex-project/edpex-project.api";
import StepperCustom from "../../../../components/step/Stepper";
import FilterSelect from "../../../../components/select/filterSelect";
import InputTextField from "../../../../components/input/inputTextField";
import { YearsApi } from "../../../../api/yeas/years.api";
import InputDatePicker from "../../../../components/input/inputDatePicker";
import moment from "moment";
import { edpexProjectAmendmentAPI } from "../../../../api/edpex-project-amendment/edpex-project-amendment.api";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SpecailEditProject from "../components/table/SpecailEditProject";
import StatusCustom from "../../../../components/status/statusCustom";
import { dateToView } from "../../../../utils/date.utils";

const FormSpecialEditRequest = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate: NavigateFunction = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const pathname = location.pathname;

  const [reloadTrigger, setReloadTrigger] = useState(false);

  const [dataYears, setDataYears] = useState<any[]>([]);

  const [showModalSpecialEdit, setShowModalSpecialEdit] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [approveMode, setApproveMode] = useState<string>("");

  const [inputValue, setInputValue] = useState<InputValueProjectForm>(
    defualtValueProjectForm
  );

  const [inputValueSpecialEdit, setInputValueSpecialEdit] = useState<any>({
    id_edpex_project_amendment: "",
    edpex_project_amendment_name: "",
    id_edpex_project_budget: "",
    fiscal_year: "",
    fiscal_month: "",
    edpex_project_budget_amount: "",
    edpex_project_start_date: "",
    edpex_project_end_date: "",
    edpex_project_amendment_remark: "",
    edpex_project_amendment_status: "",
    id_edpex_project: "",
    edpex_project_amendment_remark_cancel: "",
  });

  const titleApprove =
    approveMode === "APPROVE" ? t("อนุมัติคำร้อง") : t("ไม่อนุมัติคำร้อง");
  const subTitleApprove =
    approveMode === "APPROVE"
      ? t("ท่านต้องการอนุมัติคำร้อง ใช่หรือไม่")
      : t("กรุณาระบุหมายเหตุ");
  const alertTitle =
    approveMode === "APPROVE" ? t("อนุมัติคำร้อง") : t("ไม่อนุมัติคำร้อง");
  const alertSubTitle =
    approveMode === "APPROVE"
      ? t("อนุมัติคำร้อง เรียบร้อยแล้ว")
      : t("ไม่อนุมัติคำร้อง เรียบร้อยแล้ว");

  const fetchGetYears = async () => {
    const res = await YearsApi.getYears();
    const data = res.data;
    if (data.status < 300) {
      setDataYears(data.data);
    } else {
      setDataYears([]);
    }
  };

  useEffect(() => {
    fetchGetYears();
  }, []);

  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [projectStatusCheck, setProjectStatusCheck] = useState<string>("");

  const [step, setStep] = useState<number>(0);

  function convertFromApiFormat(apiData: any) {
    const formData: any = {
      edpex_project_indicators: [],
      edpex_project_budgets: [],
      edpex_project_responsible: [],
    };

    // Convert indicators back
    if (apiData.edpex_project_indicators) {
      formData.edpex_project_indicators = apiData.edpex_project_indicators.map(
        (indicator: any) => ({
          id: indicator.id_edpex_project_indicators
            ? indicator.id_edpex_project_indicators.toString()
            : "",
          name: indicator.edpex_project_indicators || "",
          type: indicator.edpex_project_indicators_target || "LEVEL",
          value: indicator.edpex_project_indicators_target_point || "",
          value_2: indicator.edpex_project_indicators_point || "",
        })
      );
    }

    // Convert budgets back
    if (apiData.edpex_project_budgets) {
      formData.edpex_project_budgets = apiData.edpex_project_budgets.map(
        (budget: any) => ({
          spending_info_id: budget.id_edpex_project_budget
            ? budget.id_edpex_project_budget.toString()
            : "",
          spending_info_month: budget.fiscal_month || "",
          spending_info_year: budget.fiscal_year || "",
          spending_info_value: budget.edpex_project_budget_amount
            ? budget.edpex_project_budget_amount.toString()
            : "0",
        })
      );
    }

    // Convert responsible persons back
    if (apiData.edpex_project_responsible) {
      formData.edpex_project_responsible =
        apiData.edpex_project_responsible.map((person: any) => ({
          id_employee: person.id_edpex_responsible || 0,
          name: person.name,
          employee_no: person.employee_no,
          status: person.edpex_project_responsible_type || "PRIMARY",
        }));
    }

    return formData;
  }

  const loadProjectData = useCallback(
    async (projectId: number) => {
      try {
        setIsLoading(true);
        dispatch(setLoading());

        const response = await edpexProjectAPI.getEdpexProjectById(projectId);

        if (response.data.success && response.data.data) {
          const projectData = response.data.data;

          const formData = convertFromApiFormat(projectData);

          setProjectStatusCheck(projectData.edpex_project_status);
          // Map API data to form structure
          setInputValue({
            project_name: projectData.edpex_project_name || "",
            fiscal_year: +projectData.fiscal_year + 543,
            start_date: projectData.edpex_project_start_date || "",
            end_date: projectData.edpex_project_end_date || "",
            budget: projectData.edpex_project_budget || 0,
            project_type: projectData.edpex_project_status || "",
            edpex_project_ongoing: projectData.edpex_project_ongoing,
            edpex_project_strategic_work:
              projectData.edpex_project_strategic_work,
            id_project_continue: projectData.id_edpex_project_ref || 0,

            responsible_department:
              projectData.edpex_project_department_responsible || "",
            responsible_director:
              projectData.edpex_project_user_responsible || "",
            responsible_work:
              projectData.edpex_project_division_responsible || "",

            edpex_mission: projectData.id_edpex_mission?.toString() || "",
            edpex_criteria: projectData.id_edpex_standard_point || 0,
            edpex_criteria_sub: projectData.id_edpex_standard_point_detail || 0,
            objective: projectData.edpex_project_objective || "",
            target_group: projectData.edpex_project_target_group || "",
            edpex_result: projectData.edpex_project_result || "",
            // indicatorList: projectData.edpex_project_indicators || [],
            // spendingInfo: projectData.edpex_project_budgets || [],
            // responsiblePersons: projectData.edpex_project_responsible || [],
            indicatorList: formData.edpex_project_indicators,
            spendingInfo: formData.edpex_project_budgets,
            responsiblePersons: formData.edpex_project_responsible,
            //
            description: projectData.edpex_project_remark || "",
            project_status: projectData.edpex_project_status || "",
          });

          // Load existing files with improved mapping
          if (
            projectData.edpex_project_files &&
            Array.isArray(projectData.edpex_project_files)
          ) {
            setUploadedFiles(
              projectData.edpex_project_files.map((file: any) => ({
                id: file.id,
                name: file.original_name || file.name,
                size: file.file_size || 0,
                type: file.mime_type || file.type || "",
                file_path: file.file_path || file.url,
              }))
            );
          }
        } else {
          throw new Error(response.message || t("error.loadProjectFailed"));
        }
      } catch (error: any) {
        console.error("Error loading project data:", error);
        alertError(error.message || t("error.loadProjectFailed"));
      } finally {
        setIsLoading(false);
        dispatch(unsetLoading());
      }
    },
    [dispatch, t]
  );

  const allStep: any[] = useMemo(
    () => [
      {
        name: t("รายละเอียด"),
        isAccept: true,
        icon: <ArticleOutlinedIcon />,
        disabled: false,
      },
      {
        name: t("ประวัติแก้ไขพิเศษ"),
        isAccept: true,
        icon: <EditCalendarOutlinedIcon />,
        disabled: false,
      },
    ],
    [t]
  );

  const handleUpdateStatusEditSpecial = async (status: string) => {
    try {
      dispatch(setLoading());

      const res = await edpexProjectAmendmentAPI.updateEdpexAmendmentStatus(
        +inputValueSpecialEdit.id_edpex_project_amendment,
        {
          edpex_project_amendment_status: status,
          edpex_project_amendment_remark_cancel: comment,
        }
      );

      if (res.data.status < 300) {
        alertSuccess(alertTitle, alertSubTitle, undefined, () => {
          if (id) {
            setReloadTrigger((prev) => !prev);
            handleGetDataOne(parseInt(id));
            setShowModalSpecialEdit("");
          }
        });
      }
    } catch (error: any) {
      alertError(t("เกิดข้อผิดพลาด"));
    } finally {
      dispatch(unsetLoading());
    }
  };

  const handleGetDataOne = async (id: number) => {
    try {
      dispatch(setLoading());

      const res = await edpexProjectAmendmentAPI.getEdpexProjecAmendmenttById(
        id
      );

      if (res.data?.status < 300 && res.data?.data) {
        loadProjectData(+res.data?.data?.id_edpex_project);
        setInputValueSpecialEdit &&
          setInputValueSpecialEdit(
            // res.data?.data
            {
              id_edpex_project_amendment:
                res.data?.data?.id_edpex_project_amendment,
              edpex_project_amendment_name:
                res.data?.data?.edpex_project_amendment_name,
              id_edpex_project_budget:
                res.data?.data?.edpex_amendment_detail?.id_edpex_project_budget,
              fiscal_year:
                +res.data?.data?.edpex_amendment_detail?.fiscal_year + 543,
              fiscal_month:
                res.data?.data?.edpex_amendment_detail?.fiscal_month,
              edpex_project_budget_amount:
                res.data?.data?.edpex_amendment_detail
                  ?.edpex_project_budget_amount,
              edpex_project_start_date:
                res.data?.data?.edpex_amendment_detail
                  ?.edpex_project_start_date,
              edpex_project_end_date:
                res.data?.data?.edpex_amendment_detail?.edpex_project_end_date,
              edpex_project_amendment_remark:
                res.data?.data.edpex_project_amendment_remark,
              edpex_project_amendment_status:
                res.data?.data?.edpex_project_amendment_status,
              id_edpex_project: res.data?.data?.id_edpex_project,
              edpex_project_amendment_remark_cancel:
                res.data?.data?.edpex_project_amendment_remark_cancel,
              //
              edpex_project_old_start_date:
                res.data?.data?.edpex_project_amendment?.edpex_amendment_detail
                  ?.edpex_project_start_date,
              edpex_project_old_end_date:
                res.data?.data?.edpex_project_amendment?.edpex_amendment_detail
                  ?.edpex_project_end_date,
            }
          );
      }
    } catch (error: any) {
      console.error("Get data error:", error);
    } finally {
      dispatch(unsetLoading());
    }
  };

  useEffect(() => {
    if (id) {
      handleGetDataOne(+id);
    }
  }, [id]);

  const matchedSpendingInfo = inputValue?.spendingInfo.find(
    (item: any) =>
      +item.spending_info_id === +inputValueSpecialEdit.id_edpex_project_budget
  );

  const monthOptions = [
    { name: t("มกราคม"), value: "1" },
    { name: t("กุมภาพันธ์"), value: "2" },
    { name: t("มีนาคม"), value: "3" },
    { name: t("เมษายน"), value: "4" },
    { name: t("พฤษภาคม"), value: "5" },
    { name: t("มิถุนายน"), value: "6" },
    { name: t("กรกฎาคม"), value: "7" },
    { name: t("สิงหาคม"), value: "8" },
    { name: t("กันยายน"), value: "9" },
    { name: t("ตุลาคม"), value: "10" },
    { name: t("พฤศจิกายน"), value: "11" },
    { name: t("ธันวาคม"), value: "12" },
  ];

  const getMonthName = (value: string | number | undefined) => {
    return (
      monthOptions.find((month) => month.value === String(value))?.name || "-"
    );
  };

  return (
    <>
      <ContainerLayout
        title={t("รายละเอียดคำร้อง")}
        hidden_sub_title
        sub_title_custom={
          <>
            <StatusCustom
              disableMaxWidth
              text={
                inputValueSpecialEdit.edpex_project_amendment_status ===
                  "PENDING"
                  ? t("รอการอนุมัติ")
                  : inputValueSpecialEdit.edpex_project_amendment_status ===
                    "APPROVE"
                    ? t("อนุมัติแล้ว")
                    : inputValueSpecialEdit.edpex_project_amendment_status ===
                      "REJECT"
                      ? t("ไม่อนุมัติ")
                      : ""
              }
              type={
                inputValueSpecialEdit.edpex_project_amendment_status ===
                  "PENDING"
                  ? "warning"
                  : inputValueSpecialEdit.edpex_project_amendment_status ===
                    "APPROVE"
                    ? "approve"
                    : inputValueSpecialEdit.edpex_project_amendment_status ===
                      "REJECT"
                      ? "reject"
                      : ""
              }
            />
          </>
        }
        navigateContent={
          <NavigateListCustom
            navigateData={[
              {
                key: "1",
                name: t("ระบบ Edpex"),
                disabled_match: true,
                pathName: "",
              },
              {
                key: "2",
                name: t("การขอแก้ไขพิเศษ"),
                pathName: routeName.cms.edpexSpecialEditRequest
              },
              {
                key: "3",
                name: t("โครงการ/กิจกรรม/งานที่รับผิดชอบ"),
                pathName: pathname
              },
            ]}
          />
        }
        buttonContent={
          <ContainerButton
            justifyContent="end"
            buttonData={
              id &&
                inputValueSpecialEdit.edpex_project_amendment_status === "PENDING"
                ? [
                  {
                    buttonProps: {
                      onClick: () => {
                        if (window.history.length > 0) {
                          navigate(-1);
                        } else {
                          navigate(routeName.cms.edpexSpecialEditRequest);
                        }
                      },
                    },
                    key: "CANCEL",
                    label: t("ยกเลิก"),
                    seq: 1,
                    type: "CANCEL",
                  },
                  {
                    buttonProps: {
                      onClick: () => {
                        setApproveMode("REJECT");
                      },
                    },
                    key: "REJECT",
                    label: t("ไม่อนุมัติ", { context: "action" }),
                    seq: 2,
                    type: "REJECT",
                  },
                  {
                    buttonProps: {
                      onClick: () => {
                        setApproveMode("APPROVE");
                        alertActive(
                          titleApprove,
                          subTitleApprove,
                          undefined,
                          undefined,
                          async () => {
                            handleUpdateStatusEditSpecial("APPROVE");
                          }
                        );
                      },
                    },
                    key: "APPROVE",
                    label: t("อนุมัติ", { context: "action" }),
                    seq: 3,
                    type: "APPROVE",
                  },
                ]
                : [
                  {
                    buttonProps: {
                      onClick: () => {
                        navigate(-1);
                      },
                    },
                    key: "CANCEL",
                    label: t("ยกเลิก"),
                    seq: 1,
                    type: "CANCEL",
                  },
                ]
            }
          />
        }
        content={
          <>
            <Box
              sx={{
                backgroundColor: "#faf5e6", // Light beige like in the screenshot
                borderRadius: 2,
                padding: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                width: "100%",
                margin: "0 auto",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary">
                {t("ข้อมูลที่ต้องการแก้ไข")}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#0077b6", // Blue tone to match selection
                }}
              >
                {inputValueSpecialEdit.edpex_project_amendment_name && t(inputValueSpecialEdit.edpex_project_amendment_name)}
              </Typography>

              {inputValueSpecialEdit.edpex_project_amendment_name ===
                "ขอปรับเปลี่ยนระยะเวลาเริ่มต้นดำเนินการระยะเวลาสิ้นสุดดำเนินการ" /* i18n-ignore (backend value) */ ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: "#c14400", fontWeight: "bold" }}
                  >
                    {t("ช่วงระยะเวลาเดิม :")} {dateToView(inputValue?.start_date)} -{" "}
                    {dateToView(inputValue.end_date)}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#c14400",
                      fontWeight: "bold",
                      marginLeft: 12,
                    }}
                  >
                    {t("ช่วงระยะเวลาที่ต้องการเปลี่ยน :")}{" "}
                    {dateToView(inputValueSpecialEdit.edpex_project_start_date)}{" "}
                    - {dateToView(inputValueSpecialEdit.edpex_project_end_date)}
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: "#c14400", fontWeight: "bold" }}
                  >
                    {matchedSpendingInfo
                      ? t("งวดเงินที่ต้องการแก้ไข : เดือน {{month}} (จำนวนเงิน : {{amount}})", {
                        month: getMonthName(matchedSpendingInfo?.spending_info_month),
                        amount: matchedSpendingInfo?.spending_info_value,
                      })
                      : "-"}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#c14400",
                      fontWeight: "bold",
                      marginLeft: 12,
                    }}
                  >
                    {t("แก้ไขเป็น : เดือน {{month}}(จำนวนเงิน : {{amount}})", {
                      month: getMonthName(inputValueSpecialEdit?.fiscal_month),
                      amount: inputValueSpecialEdit?.edpex_project_budget_amount,
                    })}
                  </Typography>
                </Box>
              )}

              <Typography variant="caption" color="text.secondary">
                {t("หมายเหตุ :")}{" "}
                {inputValueSpecialEdit?.edpex_project_amendment_remark_cancel}
              </Typography>
            </Box>

            <section className="flex items-center justify-center">
              <StepperCustom
                sx={{ maxWidth: "1200px" }}
                step={step}
                setStep={(num: number) => {
                  setStep(num);
                }}
                stepLabel={allStep}
                view={true}
              />
            </section>

            {step === 0 && (
              <section className="w-full mt-10">
                <IndexProjectForm
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  disable={!!id && projectStatusCheck !== "DRAFT"}
                />
              </section>
            )}

            {step === 1 && (
              <section className="w-full mt-10">
                <SpecailEditProject
                  isApprove={true}
                  reloadTrigger={reloadTrigger}
                  setShowModalSpecialEdit={setShowModalSpecialEdit}
                  setInputValueSpecialEdit={setInputValueSpecialEdit}
                  idEdpexProject={inputValueSpecialEdit.id_edpex_project}
                />
              </section>
            )}
          </>
        }
      />

      {approveMode === "REJECT" && (
        <ModalCustom
          open
          title={t("ไม่อนุมัติคำร้อง")}
          subTitle={t("")}
          onClose={() => {
            setApproveMode("");
          }}
          component={
            <div className="w-full">
              <section className="w-full mt-10">
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{
                      alignSelf: "end",
                    }}
                  >
                    <InputTextField
                      heading={t("หมายเหตุ")}
                      placeholder={t("หมายเหตุ")}
                      value={comment ?? ""}
                      onchange={(e: any) => setComment(e.target.value)}
                      helperText={""}
                      row={3}
                      maxRows={5}
                      disablePaddingMultiline
                      multiline
                      inputHeight={"auto"}
                    />
                  </Grid>
                </Grid>
              </section>

              <div className="mt-6 w-full flex justify-center gap-4 items-center">
                <span>
                  {showModalSpecialEdit !== "VIEW" && (
                    <ButtonPrimary
                      mode="del"
                      buttonName={t("ยืนยัน")}
                      onClick={() => {
                        handleUpdateStatusEditSpecial("REJECT");
                      }}
                    />
                  )}
                </span>
              </div>
            </div>
          }
        />
      )}

      {showModalSpecialEdit && (
        <ModalCustom
          open
          title={t("ส่งคำร้องขอแก้ไขพิเศษ")}
          subTitle={t("")}
          onClose={() => {
            setShowModalSpecialEdit("");
          }}
          component={
            <div className="w-full">
              <StatusCustom
                disableMaxWidth
                sx={{ maxWidth: "fit-content", px: 2.5 }}
                text={
                  inputValueSpecialEdit.edpex_project_amendment_status ===
                    "PENDING"
                    ? t("รอการอนุมัติ")
                    : inputValueSpecialEdit.edpex_project_amendment_status ===
                      "APPROVE"
                      ? t("อนุมัติแล้ว")
                      : inputValueSpecialEdit.edpex_project_amendment_status ===
                        "REJECT"
                        ? t("ไม่อนุมัติ")
                        : ""
                }
                type={
                  inputValueSpecialEdit.edpex_project_amendment_status ===
                    "PENDING"
                    ? "warning"
                    : inputValueSpecialEdit.edpex_project_amendment_status ===
                      "APPROVE"
                      ? "approve"
                      : inputValueSpecialEdit.edpex_project_amendment_status ===
                        "REJECT"
                        ? "reject"
                        : ""
                }
              />
              <section className="w-full mt-10">
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{
                      alignSelf: "end",
                    }}
                  >
                    <FilterSelect
                      value={
                        inputValueSpecialEdit.edpex_project_amendment_name ?? ""
                      }
                      labelId="ข้อมูลที่ต้องการแก้ไข-id"
                      selectId="ข้อมูลที่ต้องการแก้ไข-select-id"
                      heading={t("ข้อมูลที่ต้องการแก้ไข")}
                      options={[
                        {
                          name: t("ขอปรับเปลี่ยนระยะเวลาเริ่มต้นดำเนินการระยะเวลาสิ้นสุดดำเนินการ"),
                          value:
                            "ขอปรับเปลี่ยนระยะเวลาเริ่มต้นดำเนินการระยะเวลาสิ้นสุดดำเนินการ", // i18n-ignore (backend value)
                        },
                        {
                          name: t("ขอปรับเปลี่ยนข้อมูลการใช้เงิน"),
                          value: "ขอปรับเปลี่ยนข้อมูลการใช้เงิน", // i18n-ignore (backend value)
                        },
                      ].map((item: any, index: number) => (
                        <MenuItem value={item?.value} key={index + 1}>
                          {item?.name}
                        </MenuItem>
                      ))}
                      disabled={true}
                      onchange={(e: any) => { }}
                    />
                  </Grid>
                  {/*  */}
                  {inputValueSpecialEdit.edpex_project_amendment_name ===
                    "ขอปรับเปลี่ยนระยะเวลาเริ่มต้นดำเนินการระยะเวลาสิ้นสุดดำเนินการ" /* i18n-ignore (backend value) */ ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        {t("ระยะเวลาเดิม")}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputDatePicker
                          heading={t("ระยะเวลาเริ่มต้นดำเนินการ")}
                          placeholder={t("ระยะเวลาเริ่มต้นดำเนินการ")}
                          value={inputValue.start_date ?? ""}
                          onChange={(e: any) => { }}
                          helperText={""}
                          disabled={true}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputDatePicker
                          heading={t("ระยะเวลาสิ้นสุดดำเนินการ")}
                          placeholder={t("ระยะเวลาสิ้นสุดดำเนินการ")}
                          value={inputValue.end_date ?? ""}
                          onChange={(e: any) => { }}
                          helperText={""}
                          disabled={true}
                        />
                      </Grid>
                      {/*  */}
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        {t("ระยะเวลาที่ต้องการแก้ไข")}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputDatePicker
                          heading={t("ระยะเวลาเริ่มต้นดำเนินการ")}
                          placeholder={t("ระยะเวลาเริ่มต้นดำเนินการ")}
                          value={
                            inputValueSpecialEdit.edpex_project_start_date ?? ""
                          }
                          onChange={(e: any) => { }}
                          helperText={""}
                          disabled={true}
                          disableStartDate={
                            inputValue.fiscal_year - 544 + "-10-01"
                          }
                          disableEndDate={
                            inputValue.fiscal_year - 543 + "-09-30"
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputDatePicker
                          heading={t("ระยะเวลาสิ้นสุดดำเนินการ")}
                          placeholder={t("ระยะเวลาสิ้นสุดดำเนินการ")}
                          value={
                            inputValueSpecialEdit.edpex_project_end_date ?? ""
                          }
                          onChange={(e: any) => { }}
                          disableStartDate={
                            inputValue.fiscal_year - 544 + "-10-01"
                          }
                          disableEndDate={
                            inputValue.fiscal_year - 543 + "-09-30"
                          }
                          helperText={""}
                          disabled={true}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputTextField
                          heading={t("หมายเหตุ")}
                          placeholder={t("หมายเหตุ")}
                          value={
                            inputValueSpecialEdit.edpex_project_amendment_remark ??
                            ""
                          }
                          onchange={(e: any) => { }}
                          disabled={true}
                          helperText={""}
                          row={3}
                          maxRows={5}
                          disablePaddingMultiline
                          multiline
                          inputHeight={"auto"}
                        />
                      </Grid>
                    </>
                  ) : inputValueSpecialEdit.edpex_project_amendment_name ===
                    "ขอปรับเปลี่ยนข้อมูลการใช้เงิน" /* i18n-ignore (backend value) */ ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <FilterSelect
                          value={
                            inputValueSpecialEdit.id_edpex_project_budget ?? ""
                          }
                          labelId="งวดเงินที่ต้องการแก้ไข-id"
                          selectId="งวดเงินที่ต้องการแก้ไข-select-id"
                          heading={t("งวดเงินที่ต้องการแก้ไข")}
                          options={inputValue.spendingInfo.map(
                            (item: any, index: number) => (
                              <MenuItem
                                value={item?.spending_info_id}
                                key={index + 1}
                              >
                                {t("เดือน {{month}} ปีงบประมาณ {{year}} (จำนวนเงิน : {{amount}})", { month: item?.spending_info_month, year: item?.spending_info_year, amount: item?.spending_info_value })}
                              </MenuItem>
                            )
                          )}
                          disabled={true}
                          onchange={(e: any) => { }}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        {t("แก้ไขเป็น")}
                      </Grid>
                      {/*  */}
                      <Grid
                        item
                        xs={12}
                        md={4}
                        lg={4}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <FilterSelect
                          value={inputValueSpecialEdit.fiscal_month ?? ""}
                          labelId="เดือนที่ใช้-id"
                          selectId="เดือนที่ใช้-select-id"
                          heading={t("เดือนที่ใช้")}
                          options={[...monthOptions].map(
                            (item: any, index: number) => (
                              <MenuItem value={item?.value} key={index + 1}>
                                {item?.name}
                              </MenuItem>
                            )
                          )}
                          disabled={true}
                          onchange={(e: any) => { }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={4}
                        lg={4}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputTextField
                          heading={t("จำนวนเงิน")}
                          placeholder={t("จำนวนเงิน")}
                          value={
                            inputValueSpecialEdit.edpex_project_budget_amount ??
                            ""
                          }
                          onchange={(e: any) => { }}
                          required
                          helperText={""}
                          disabled={true}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={4}
                        lg={4}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <FilterSelect
                          value={inputValueSpecialEdit.fiscal_year ?? ""}
                          labelId="ทุกปีงบปะมาณ-id"
                          selectId="ทุกปีงบปะมาณ-select-id"
                          heading={t("ทุกปีงบปะมาณ")}
                          options={[{ year: "ทุกปีงบปะมาณ" /* i18n-ignore (option value; label translated below) */ }, ...dataYears].map(
                            (item: any, index: number) => (
                              <MenuItem value={item?.year} key={index + 1}>
                                {index === 0 ? t("ทุกปีงบปะมาณ") : item?.year}
                              </MenuItem>
                            )
                          )}
                          onchange={(e: any) => { }}
                          disabled={true}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          alignSelf: "end",
                        }}
                      >
                        <InputTextField
                          heading={t("หมายเหตุ")}
                          placeholder={t("หมายเหตุ")}
                          value={
                            inputValueSpecialEdit.edpex_project_amendment_remark ??
                            ""
                          }
                          onchange={(e: any) => { }}
                          helperText={""}
                          row={3}
                          maxRows={5}
                          disablePaddingMultiline
                          multiline
                          inputHeight={"auto"}
                          disabled={true}
                        />
                      </Grid>
                    </>
                  ) : null}
                </Grid>
              </section>

              <div className="mt-6 w-full flex justify-center gap-4 items-center">
                <span>
                  <ButtonPrimary
                    mode="cancel"
                    buttonName={t("BUTTON.CANCEL")}
                    onClick={() => {
                      setShowModalSpecialEdit("");
                    }}
                  />
                </span>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default FormSpecialEditRequest;
